import { createTheme } from "@mui/material/styles";

export const Theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: "#FFFF",
          ":hover": {
            backgroundColor: "#484848",
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          color: "#484848",
          backgroundColor: "#2f2f2f",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#383838",
          color: "#FFFF",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderColor: "#848484",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "rgba(255, 255, 255, 0.6)",
        },
      },
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif",
    color: "white",
  },
});
